
import FirmwareVersionsTable from "@/components/firmwares/FirmwareVersionsTable.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    FirmwareVersionsTable,
  },
})
export default class FirmwareVersionsView extends Vue {
  //
}
